<template>
  <!-- footer -->
  <footer id="ft">
    <div class="inwrap">
      <p class="logo_white"><img :src="`${publicPath}img/common/main_footer_logo.png`" alt=""></p>
      <address>
        <p>
          <span>상호 : 오늘하루치과의원</span>
          <span>주소 : 서울특별시 동작구 동작대로 89 골든시네마타워 7층</span>
          <span>대표자 : 김홍석</span>
          <span>사업자등록번호 108-21-26105</span>
        </p>
        <p>
          <span>대표전화 02-522-2828</span>
          <span>이메일 today8575@naver.com</span>
          <span class="copyright">Copyright 2019, 1DAY DENTAL CLINIC ALL RIGHT RESERVED.</span>
        </p>
      </address>
    </div>
  </footer>
  <!-- e : footer -->
</template>

<script>
export default {
  name: 'OneDayFooter',
};
</script>

<style scoped>

</style>
